import { render, staticRenderFns } from "./DiscountApprovals.vue?vue&type=template&id=3e467d4c&"
import script from "./DiscountApprovals.vue?vue&type=script&lang=js&"
export * from "./DiscountApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports